import { OldAddress } from '$core/models/old-address';
import { ContractAddress } from '$core/models/contract-address';
import { BelpostRepublicAddress } from '$shared/types/belpost-republic-address';

// TODO потом выпилить OldAddress из вариантов трансформации
function isBelpostAddress(
  address: BelpostRepublicAddress | OldAddress
): address is BelpostRepublicAddress {
  return 'external_id' in address;
}

export const convertToContractAddress = (
  address: BelpostRepublicAddress | OldAddress
): ContractAddress => {
  return new ContractAddress({
    id: isBelpostAddress(address) ? address.external_id : address.id,
    code: address.postcode,
    region: address.region,
    district: address.district,
    locality: {
      type: address.city_type,
      name: address.city,
    },
    road: {
      type: address.street_type,
      name: address.street,
    },
    building: address.house,
    housing: isBelpostAddress(address) ? address.block : address.building,
    apartment: address.flat,
  });
};
